/**
 * Nidra Ajax Cart Drawer - Premium Rebuild
 * Faithful reproduction of approved visual reference (media_1788888676288.png)
 * Seamless Shopify Ajax Cart Integration
 */
(function() {
  'use strict';

  // Canonical Variant Discount & Pricing Matrix (Phase 2E)
  const VARIANT_PRICING = {
    49468384772311: { cod: 1499, prepaid: 1349, saving: 150, code: 'PREPAID150' }, // Compact 1
    49475383886039: { cod: 2898, prepaid: 2598, saving: 300, code: 'PREPAID300' }, // Compact 2
    49475383918807: { cod: 4197, prepaid: 3747, saving: 450, code: 'PREPAID450' }, // Compact 3
    49526425944279: { cod: 1899, prepaid: 1709, saving: 190, code: 'PREPAID190' }, // Regular 1
    49526426009815: { cod: 3700, prepaid: 3298, saving: 402, code: 'PREPAID402' }, // Regular 2
    49526426075351: { cod: 5397, prepaid: 4797, saving: 600, code: 'PREPAID600' }, // Regular 3
    49526425977047: { cod: 2099, prepaid: 1889, saving: 210, code: 'PREPAID210' }, // Plus 1
    49526426042583: { cod: 3998, prepaid: 3598, saving: 400, code: 'PREPAID400' }, // Plus 2
    49526426108119: { cod: 5697, prepaid: 5097, saving: 600, code: 'PREPAID600-L' }  // Plus 3
  };
  const STACKED_PILLOWS_IMG = (window.ShopifyTheme && window.ShopifyTheme.assets && window.ShopifyTheme.assets.stacked_pillows) || '/cdn/shop/t/1/assets/nidra-stacked-pillows.png';

  function inr(n) {
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  // Icons used inside the cart drawer
  const ICONS = {
    tag: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/></svg>',
    minus: '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>',
    truck: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18.5" r="2.5"/><circle cx="7" cy="18.5" r="2.5"/></svg>',
    clock: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    shield: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>',
    banknote: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="12" x="2" y="6" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg>',
    rotateCcw: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
    lock: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    chevronRight: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
  };

  class CartManager {
    constructor() {
      this.overlay = document.getElementById('CartDrawerOverlay');
      this.panel = document.getElementById('CartDrawerPanel');
      this.content = document.getElementById('CartDrawerContent');
      this.closeBtn = document.getElementById('CartDrawerClose');
      this.openBtn = document.getElementById('CartDrawerOpen');
      this.headTitle = document.getElementById('CartHeadTitle');
      this.countBadge = document.getElementById('CartItemCount');
      this.isOpen = false;
      this.isPrepaid = true;
      this.previousFocusedElement = null;

      try {
        if (localStorage.getItem('nidra:payment_mode') === 'cod') {
          this.isPrepaid = false;
        }
      } catch (e) { /* ignore */ }

      this.lastCart = null;
      this.initEvents();

      // Instant render from server-rendered JSON (zero network overhead, avoids 429)
      try {
        const initDataEl = document.getElementById('CartDrawerInitialData');
        if (initDataEl && initDataEl.textContent.trim()) {
          const initCart = JSON.parse(initDataEl.textContent);
          this.render(initCart);
        } else {
          this.refresh();
        }
      } catch (e) {
        this.refresh();
      }
    }

    initEvents() {
      if (this.openBtn) {
        this.openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) this.close();
        });
      }

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });
    }

    open() {
      if (!this.overlay) return;
      this.previousFocusedElement = document.activeElement;
      this.isOpen = true;
      this.overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      this.refresh();

      if (this.closeBtn) {
        setTimeout(() => this.closeBtn.focus(), 50);
      }
    }

    close() {
      if (!this.overlay) return;
      this.isOpen = false;
      this.overlay.style.display = 'none';
      document.body.style.overflow = '';
      if (this.previousFocusedElement && typeof this.previousFocusedElement.focus === 'function') {
        this.previousFocusedElement.focus();
      }
    }

    async fetchCart() {
      try {
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return null;
        return await res.json();
      } catch (e) {
        return null;
      }
    }

    async addItem({ id, quantity, size, pack, prepaid }) {
      if (typeof prepaid === 'boolean') {
        this.isPrepaid = prepaid;
        try {
          localStorage.setItem('nidra:payment_mode', this.isPrepaid ? 'prepaid' : 'cod');
        } catch (e) { /* ignore */ }
      }

      const properties = {
        'Size': size || 'S',
        'Pack': pack ? (pack + ' pillow' + (pack > 1 ? 's' : '')) : '1 pillow',
        'Payment': this.isPrepaid ? 'Prepaid' : 'Cash on Delivery'
      };

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity, properties })
      });

      if (!res.ok) {
        throw new Error('Failed to add item to cart');
      }

      await this.refresh();
      this.open();
    }

    async updateItem(line, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (res.ok) {
        await this.refresh();
      }
    }

    async clearCart() {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
      await this.refresh();
    }

    async refresh() {
      try {
        const cart = await this.fetchCart();
        if (cart) {
          this.render(cart);
        }
      } catch (err) {
        console.warn('Error refreshing cart:', err);
      }
    }

    render(cart) {
      this.lastCart = cart;

      // Update badge in header
      if (this.countBadge) {
        this.countBadge.textContent = cart.item_count;
      }

      // Update drawer head title in uppercase: YOUR BAG · X ITEMS
      if (this.headTitle) {
        const itemText = cart.item_count === 1 ? 'ITEM' : 'ITEMS';
        this.headTitle.innerHTML = `YOUR BAG &middot; ${cart.item_count} ${itemText}`;
      }

      if (!this.content) return;

      // Empty State
      if (cart.item_count === 0) {
        this.content.innerHTML = `
          <div class="cart-empty-wrap">
            <div class="cart-empty-image">
              <img src="${STACKED_PILLOWS_IMG}" onerror="this.src='/cdn/shop/files/ChatGPTImageJul16_2026_04_29_25PM.png'" alt="Nidra cervical pillow">
            </div>
            <h3 class="cart-empty-title">Your bag is resting.</h3>
            <p class="cart-empty-desc">Add your Nidra pillow and wake up to better mornings.</p>
            <a href="/products/nidra-cervical-memory-foam-pillow" class="btn btn-primary cart-empty-cta" id="CartEmptyCta">
              Choose your pillow
            </a>
          </div>
        `;
        const emptyCta = document.getElementById('CartEmptyCta');
        if (emptyCta) {
          emptyCta.addEventListener('click', () => this.close());
        }
        return;
      }

      // 1. Determine Cart Type & Calculate totals
      let originalTotal = 0;
      cart.items.forEach(item => {
        originalTotal += (item.price * item.quantity) / 100;
      });

      // Single-pack detection: exactly 1 line item with quantity 1 matching one of our 9 approved packs
      const isSinglePack = cart.items.length === 1 && cart.items[0].quantity === 1 && Boolean(VARIANT_PRICING[cart.items[0].id]);
      const singlePackInfo = isSinglePack ? VARIANT_PRICING[cart.items[0].id] : null;

      let discount = 0;
      let discountCode = null;
      if (isSinglePack && this.isPrepaid && singlePackInfo) {
        discount = singlePackInfo.saving;
        discountCode = singlePackInfo.code;
      }
      const finalTotal = originalTotal - discount;

      // 2. Top dynamic savings bar
      let savingsBarHtml = '';
      if (isSinglePack && this.isPrepaid && discount > 0) {
        savingsBarHtml = `
          <div class="cart-savings-bar" id="CartSavingsBar">
            <span class="savings-bar-icon">${ICONS.tag}</span>
            <span class="savings-bar-text">You're saving <strong>${inr(discount)}</strong> with prepaid payment</span>
          </div>
        `;
      } else if (!isSinglePack && cart.items.length > 0) {
        savingsBarHtml = `
          <div class="cart-savings-bar" id="CartSavingsBar" style="background:#f4f5f6;color:#555;">
            <span class="savings-bar-icon">${ICONS.tag}</span>
            <span class="savings-bar-text">Multi-pack order &middot; Standard catalog pricing applies</span>
          </div>
        `;
      }

      // 3. Line items list
      let linesHtml = '<ul class="cart-lines-list">';
      cart.items.forEach((item, index) => {
        const lineNum = index + 1;
        const itemUnitPrice = item.price / 100;
        // Line price reflects exact prepaid pack price for single packs, or catalog price
        const itemLinePrice = (isSinglePack && this.isPrepaid && singlePackInfo)
          ? singlePackInfo.prepaid
          : itemUnitPrice * item.quantity;

        const imgSrc = item.image || (item.featured_image && item.featured_image.url) || '';

        // Options / Subtitle formatting
        let subtitle = item.variant_title || 'Compact · 1 pillow';
        subtitle = subtitle.replace(/\s*\/\s*/g, ' / ');
        const paymentLabel = (isSinglePack && this.isPrepaid) ? 'Prepaid' : 'Standard / COD';
        const fullVariantText = `${subtitle} / ${paymentLabel}`;

        linesHtml += `
          <li class="cart-line-card" data-line="${lineNum}">
            <div class="cart-line-thumb">
              <img src="${imgSrc}" alt="${item.title || 'Nidra pillow'}" loading="lazy">
            </div>
            <div class="cart-line-info">
              <div class="cart-line-title-row">
                <h4 class="cart-line-title">${item.product_title || item.title}</h4>
              </div>
              <p class="cart-line-variant">${fullVariantText}</p>
              <div class="cart-line-controls">
                <div class="cart-pill-stepper" role="group" aria-label="Change quantity">
                  <button type="button" class="stepper-btn qty-minus" data-line="${lineNum}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">
                    ${ICONS.minus}
                  </button>
                  <span class="stepper-qty" aria-live="polite">${item.quantity}</span>
                  <button type="button" class="stepper-btn qty-plus" data-line="${lineNum}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">
                    ${ICONS.plus}
                  </button>
                </div>
                <div class="cart-line-price-wrap">
                  <span class="cart-line-price">${inr(itemLinePrice)}</span>
                </div>
                <button type="button" class="cart-remove-btn qty-remove" data-line="${lineNum}" aria-label="Remove item">
                  ${ICONS.trash}
                </button>
              </div>
            </div>
          </li>
        `;
      });
      linesHtml += '</ul>';

      // 4. "ADD MORE, SAVE MORE." Upsell Card with stacked pillows
      const upsellHtml = `
        <div class="cart-upsell-card">
          <div class="cart-upsell-text">
            <h5 class="cart-upsell-title">ADD MORE, SAVE MORE.</h5>
            <p class="cart-upsell-desc">A 2 or 3 pillow set costs less per pillow than buying one at a time.</p>
            <a href="/products/nidra-cervical-memory-foam-pillow" class="cart-upsell-link" id="CartUpsellLink">
              Add another pillow <span class="upsell-arrow">&rarr;</span>
            </a>
          </div>
          <div class="cart-upsell-media">
            <img src="${STACKED_PILLOWS_IMG}" alt="Nidra stacked pillows set" loading="lazy">
          </div>
        </div>
      `;

      // 5. Side-by-side Payment Mode Selector Cards
      const paymentCardsHtml = `
        <div class="cart-payment-modes" role="radiogroup" aria-label="Select payment mode">
          <button type="button" class="cart-mode-card ${this.isPrepaid ? 'is-active' : ''}" id="CartModePrepaidCard" role="radio" aria-checked="${this.isPrepaid}">
            <div class="mode-card-header">
              <span class="mode-radio-circle">${this.isPrepaid ? ICONS.check : ''}</span>
              <span class="mode-card-title">Pay Online${isSinglePack && discount > 0 ? ` (Save ${inr(discount)})` : ''}</span>
            </div>
            <span class="mode-card-sub">${isSinglePack && discount > 0 ? `Extra ${inr(discount)} discount applied` : 'UPI, Cards, NetBanking'}</span>
          </button>
          <button type="button" class="cart-mode-card ${!this.isPrepaid ? 'is-active' : ''}" id="CartModeCodCard" role="radio" aria-checked="${!this.isPrepaid}">
            <div class="mode-card-header">
              <span class="mode-radio-circle">${!this.isPrepaid ? ICONS.check : ''}</span>
              <span class="mode-card-title">Cash on Delivery</span>
            </div>
            <span class="mode-card-sub">Pay at your doorstep</span>
          </button>
        </div>
      `;

      // 6. 4-column Trust Strip with vertical dividers
      const trustStripHtml = `
        <div class="cart-trust-strip">
          <div class="trust-strip-item">
            <span class="trust-icon">${ICONS.truck}</span>
            <div class="trust-label">
              <strong class="trust-title">Free delivery</strong>
              <small class="trust-sub">Across India</small>
            </div>
          </div>
          <div class="trust-strip-item">
            <span class="trust-icon">${ICONS.clock}</span>
            <div class="trust-label">
              <strong class="trust-title">24h dispatch</strong>
              <small class="trust-sub">Every working day</small>
            </div>
          </div>
          <div class="trust-strip-item">
            <span class="trust-icon">${ICONS.rotateCcw}</span>
            <div class="trust-label">
              <strong class="trust-title">48h replacement</strong>
              <small class="trust-sub">Video-verified</small>
            </div>
          </div>
          <div class="trust-strip-item">
            <span class="trust-icon">${ICONS.banknote}</span>
            <div class="trust-label">
              <strong class="trust-title">Cash on delivery</strong>
              <small class="trust-sub">Available nationwide</small>
            </div>
          </div>
        </div>
      `;

      // 7. Order Summary
      const summaryHtml = `
        <div class="cart-summary-section">
          <div class="summary-row">
            <span class="summary-label">Original amount</span>
            <span class="summary-value">${inr(originalTotal)}</span>
          </div>
          ${isSinglePack && this.isPrepaid && discount > 0 ? `
            <div class="summary-row summary-savings-row">
              <span class="summary-label">Prepaid discount</span>
              <span class="summary-value saving-value">−${inr(discount)}</span>
            </div>
          ` : ''}
          <div class="summary-row">
            <span class="summary-label">Shipping</span>
            <span class="summary-value free-value">Free</span>
          </div>
          <div class="summary-divider"></div>
          <div class="summary-row total-row">
            <span class="total-label">Total</span>
            <span class="total-value">${inr(finalTotal)}</span>
          </div>
          <p class="summary-tax-note">
            ${isSinglePack && this.isPrepaid
              ? `${inr(discount)} online savings applied. Taxes included.`
              : (isSinglePack
                  ? 'Cash on delivery: standard catalog price payable upon arrival. Handling fee applies at checkout.'
                  : 'Multi-pack order: standard catalog pricing applies. Cash on delivery & online payment available at checkout.')}
          </p>
        </div>
      `;

      // 8. Checkout CTA
      let checkoutUrl = '/checkout';
      if (isSinglePack && this.isPrepaid && discountCode) {
        checkoutUrl = '/checkout?discount=' + encodeURIComponent(discountCode);
      }
      const ctaPaymentSuffix = (isSinglePack && this.isPrepaid) ? ' (Prepaid)' : ' (COD / Standard)';

      const checkoutCtaHtml = `
        <a href="${checkoutUrl}" class="cart-checkout-cta" id="CartCheckoutBtn">
          <span class="cta-left">
            <span class="cta-icon">${ICONS.lock}</span>
            <span class="cta-label">Secure checkout</span>
          </span>
          <span class="cta-right">
            <span class="cta-amount">&middot; ${inr(finalTotal)}${ctaPaymentSuffix}</span>
            <span class="cta-arrow">${ICONS.chevronRight}</span>
          </span>
        </a>
      `;

      // 9. 3-column Bottom Reassurance
      const bottomTrustHtml = `
        <div class="cart-bottom-trust">
          <span class="bottom-trust-item">Secure payments (Razorpay)</span>
          <span class="bottom-trust-bullet">&middot;</span>
          <span class="bottom-trust-item">Safe & encrypted</span>
          <span class="bottom-trust-bullet">&middot;</span>
          <span class="bottom-trust-item">100% genuine</span>
        </div>
      `;

      // 10. Clear Bag Link
      const clearBagHtml = `
        <div class="cart-clear-wrap">
          <button type="button" class="cart-clear-btn" id="CartClearBtn">Clear bag</button>
        </div>
      `;

      // Assemble content
      this.content.innerHTML = `
        <div class="cart-scroll-area">
          ${savingsBarHtml}
          <div class="cart-body-inner">
            ${linesHtml}
            ${upsellHtml}
            ${paymentCardsHtml}
            ${trustStripHtml}
          </div>
        </div>
        <div class="cart-footer-area">
          ${summaryHtml}
          ${checkoutCtaHtml}
          ${bottomTrustHtml}
          ${clearBagHtml}
        </div>
      `;

      // Attach Event Listeners
      // Payment mode toggles
      const prepaidCard = this.content.querySelector('#CartModePrepaidCard');
      const codCard = this.content.querySelector('#CartModeCodCard');

      if (prepaidCard) {
        prepaidCard.addEventListener('click', () => {
          if (!this.isPrepaid) {
            this.isPrepaid = true;
            try { localStorage.setItem('nidra:payment_mode', 'prepaid'); } catch (e) { /* ignore */ }
            if (this.lastCart) this.render(this.lastCart);
          }
        });
      }

      if (codCard) {
        codCard.addEventListener('click', () => {
          if (this.isPrepaid) {
            this.isPrepaid = false;
            try {
              localStorage.setItem('nidra:payment_mode', 'cod');
              document.cookie = 'discount_code=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            } catch (e) { /* ignore */ }
            if (this.lastCart) this.render(this.lastCart);
          }
        });
      }

      // Checkout Button
      const checkoutBtn = this.content.querySelector('#CartCheckoutBtn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
          if (!this.isPrepaid) {
            try {
              document.cookie = 'discount_code=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            } catch (e) { /* ignore */ }
          }
        });
      }

      // Quantity adjustments
      this.content.querySelectorAll('.qty-minus').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const line = parseInt(btn.getAttribute('data-line'), 10);
          const qty = parseInt(btn.getAttribute('data-qty'), 10);
          this.updateItem(line, Math.max(0, qty));
        });
      });

      this.content.querySelectorAll('.qty-plus').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const line = parseInt(btn.getAttribute('data-line'), 10);
          const qty = parseInt(btn.getAttribute('data-qty'), 10);
          this.updateItem(line, qty);
        });
      });

      this.content.querySelectorAll('.qty-remove').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const line = parseInt(btn.getAttribute('data-line'), 10);
          this.updateItem(line, 0);
        });
      });

      // Clear Bag
      const clearBtn = this.content.querySelector('#CartClearBtn');
      if (clearBtn) {
        clearBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearCart();
        });
      }

      // Upsell Link
      const upsellLink = this.content.querySelector('#CartUpsellLink');
      if (upsellLink) {
        upsellLink.addEventListener('click', () => {
          this.close();
        });
      }
    }
  }

  // Mount to window immediately or on DOMContentLoaded
  function initCart() {
    if (!window.NidraCart) {
      window.NidraCart = new CartManager();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }
})();
